import type { ColorPatternName } from '../../Colors'

export const ChartBarConstants = {
  /** NextGen PTP grouped vertical bars (293:27967): ~20px each. */
  defaultBarSize: 20,
  /** Gap between bars in a grouped cluster (20+4+20). */
  defaultBarGap: 4,
  /**
   * NextGen Unlading Port Dwell horizontal bars (293:28130).
   * Category gap is leftover plot height (Figma Auto), not a fixed token.
   */
  defaultHorizontalBarSize: 12,
  /** Figma bars are square — no corner radius. */
  defaultCornerRadius: 0,
  defaultBarOrientation: 'vertical' as const,
  defaultBarLayout: 'grouped' as const,
  defaultColorPattern: 'qualitative.default' as ColorPatternName,
  /** Figma legend swatch for bar series (8×8 square). */
  legendSwatchSizePx: 8,
  /**
   * NextGen grouped vertical (293:27967): space between category clusters.
   */
  verticalCategoryGapPx: 36,
  /** Fixed measure domain for stacked100 (percent of category total). */
  stacked100Domain: [0, 100] as [number, number],
  stacked100Ticks: [0, 25, 50, 75, 100],
}
